import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { UpdateIncidentFile } from '../mutations/updateIncidentFile.mutation';
import type { UpdateIncidentFileMutation, UpdateIncidentFileMutationVariables } from '../types';

export const useUpdateIncidentFileMutation = (
  options?: MutationOptions<UpdateIncidentFileMutation, UpdateIncidentFileMutationVariables>,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(UpdateIncidentFile), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('incident'),
      });
    },
  });
};
